import React, { Component } from "react";
import { converDateIntoLocal } from "Constants";
import LocaleStrings from "Languages";
const sortBy = [
  {
    value: "accepted",
    label: LocaleStrings.content_community_manage_members_accpected,
  },
  {
    value: "requested",
    label: LocaleStrings.content_community_manage_members_requested,
  },
  {
    value: "removed",
    label: LocaleStrings.content_community_manage_members_removed,
  },
  {
    value: "left",
    label: LocaleStrings.content_community_manage_members_left,
  },
  {
    value: "rejected",
    label: LocaleStrings.content_community_manage_members_rejected,
  },
];

export default class UsersCell extends Component {
  onCheckChange = (e) => {
    this.props.toggleSelection(this.props.user);
  };

  deleteCallback = () => {
    this.props.removeFromSelected(this.props.user);
  };

  statusChangeCallback = (e) => {
    this.props.statusChangeselected(this.props.user, e.target.value);
  };

  render() {
    var { username, email, status, isrsvp, rsvptime } = this.props.user;
    var { checked, selectedusers } = this.props;
    var style = { fontSize: 10, overflowWrap: "break-word", color: "#4da1ff" };
    let flag = this.props.flag ? this.props.flag : "";
    let isDisabled = this.props.isDisabled ? this.props.isDisabled : false;

    return selectedusers === false ? (
      <tr>
        <td>
          <div className="vertical-align-center">
            <label className="custom-container-checkbox">
              <input
                type="checkbox"
                onChange={this.onCheckChange}
                checked={checked}
                disabled={isDisabled}
              />
              <span className="checkmark" disabled={isDisabled} />
            </label>
            <div>
              <div>{username}</div>
              <span style={style}>{email}</span>
            </div>
          </div>
        </td>
        {/* <td>{email}</td> */}
      </tr>
    ) : (
      <tr style={{ borderBottom: "1px solid #e6edf3" }}>
        <td style={{ width: "60%" }}>
          <div>
            <div>{username}</div>
            <span style={style}>{email}</span>
          </div>
          {isrsvp ? (
            <div className="schedule-interest-section">
              <div className="selected-interest">
                {LocaleStrings.rsvp}{" "}
                <span style={style}>
                  {rsvptime ? converDateIntoLocal(rsvptime) : ""}
                </span>
                <span>
                  &nbsp; <i className="fa fa-check" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          ) : (
            ""
          )}
        </td>
        <td style={{ width: "40%" }} align="right">
          <div className="vcenter">
            {flag === "COMMUNITY" ? (
              isDisabled ? (
                <select
                  className="form-control dropdown-height-border content-table-header-selectrandomly"
                  placeholder="Sort by name"
                  onChange={(e) => this.statusChangeCallback(e)}
                  // value={this.state.sort}
                  defaultValue={status}
                >
                  {sortBy.map((object, index) => {
                    return (
                      <option
                        key={`${object.value}-${index}`}
                        value={object.value}
                      >
                        {object.label}
                      </option>
                    );
                  })}
                </select>
              ) : (
                <button
                  className="btn  btn-sm btn-delete modal-table-cross"
                  onClick={this.deleteCallback}
                >
                  X
                </button>
              )
            ) : (
              <button
                className="btn  btn-sm btn-delete modal-table-cross"
                onClick={this.deleteCallback}
              >
                X
              </button>
            )}
          </div>
        </td>
      </tr>
    );
  }
}
